<template>
    <v-row class="ma-0 pa-0">
        <v-col md="2" sm="12" cols="12">
            <Sidebar></Sidebar>
        </v-col>
        <v-col md="10" sm="12">
            <div class="headline">
                <h1 class="headline">Constitution</h1>
                    <v-breadcrumbs divider=">" :items="breadcrumbs"></v-breadcrumbs>
                    <v-container>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <GoogleSearchStatute></GoogleSearchStatute>
                            </v-flex>
                        </v-layout>
                    </v-container>
            </div>
            <v-divider></v-divider>
            <FilterableDataTable :headers="headers"
                                 :items="items"
                                 item-key="StatuteId"
                                 disable-pagination
                                 :sort-by="sortBy"
                                 :sort-desc="[false]"
                                 :loading="loading"
                                 loading-text="Loading... Please wait"
                                 hide-default-footer
                                 class="elevation-1">
                <template v-slot:item.Chapter="{ item }">
                    <span v-if="item.Chapter == 0"></span>
                    <span v-else>
                        <router-link :to="'/Constitution/' + item.Statute.replace('0N-', '')" style="text-decoration: none;" :aria-label="'View ' + item.Statute.replace('0N-', '') + ' Chapter Details'">
                            {{item.Chapter}}
                        </router-link>
                    </span>
                </template>
                <template v-slot:item.CatchLine="{ item }">
                    <div v-if="item.Statute == '0N-Preamble'">
                        <router-link :to="'/Constitution/' + item.Statute.replace('0N-', '')" style="text-decoration: none;">{{item.CatchLine}}</router-link>
                    </div>
                    <div v-else>
                        <div class="hidden-md-and-up">
                            {{item.CatchLine}}
                        </div>
                        <div class="hidden-sm-and-down">
                            {{shortenCell(item.CatchLine)}}
                        </div>
                    </div>
                </template>
                <template v-slot:no-data>
                    <v-alert v-if="loading" :value="true" type="info">
                        Loading Please wait
                    </v-alert>
                    <v-alert v-else :value="true" type="info">
                        No Results
                    </v-alert>
                </template>
            </FilterableDataTable>
        </v-col>
    </v-row>

</template>
<script>
    const GoogleSearchStatute = () => import("@/Components/GoogleSearchStatute.vue");
    const Sidebar = () => import("@/Menus/Sidebar.vue");
    const FilterableDataTable = () => import("@/Components/FilterableDataTable.vue");

    export default {
        name: 'ConstitutionalArticles',
        props: [],
        components: {
            GoogleSearchStatute,
            Sidebar,
            FilterableDataTable
        },
        methods: {
            LoadData()
            {
                this.loading = true;
                this.createBreadcrumbs('Constitution', '/Constitution');

                fetch('/api/Statutes/Constitution',
                    {
                        method: "GET",
                        credentials: "include",
                        headers: { "Content-Type": "application/json" },
                    })
                    .then(res =>
                    {
                        if (res.ok)
                            return res.json();
                        else
                            return res.text().then(r => Promise.reject(r));
                    })
                    .then(response =>
                    {
                        this.items = EncodeDatetimes(response);
                    })
                    .catch(error =>
                    {
                        if (error == 404)
                            window.location.href = "/404?path=" + encodeURIComponent(window.location.pathname);
                        else if (error != 302)
                        {
                            let e = '';
                            let ff = true;

                            try
                            {
                                e = String(error).substring(0, 100);
                                ff = (e || '').indexOf('Failed to fetch') > -1;

                                if (!ff && (e || '') == '')
                                    ff = true;
                            }
                            catch (ee) { }

                            if (ff)
                            {
                                window.location.href = "/400?path=" + encodeURIComponent(window.location.pathname) + '&error=' + encodeURIComponent(e);
                            }
                            else
                            {
                                reportError(error);
                                window.location.href = "/500?path=" + encodeURIComponent(window.location.pathname) + '&error=' + encodeURIComponent(e);
                            }
                        }
                    })
                    .finally(() =>
                    {
                        this.loading = false;
                    });
            },

            createBreadcrumbs(route, url)
            {
                this.breadcrumbs = [{
                    to: '/',
                    link: true,
                    text: 'Home',
                }];

                var bci2 = {
                    to: '',
                    link: true,
                    text: '',
                };
                bci2.to = url;
                bci2.text = route;
                bci2.disabled = true;

                this.breadcrumbs.push(bci2);
            },
            shortenCell(str)
            {
                if (str != null)
                {
                    if (str.length > 160)
                    {
                        return str.substring(0, 160);
                    } else
                    {
                        return str;
                    }
                }
            }

        },
        data: function ()
        {
            return {
                loading: false,
                sortBy: ['Article'],
                quickFind: null,
                breadcrumbs: [],
                items: [],
                headers: [

                    {
                        text: 'Article',
                        value: 'Chapter',
                        Type: 'Constitution',
                        width: '15ch'
                    },
                    {
                        text: 'Catchline',
                        value: 'CatchLine',
                        Type: 'Statute',
                        width: '*'
                    },

                ],
                rulefilter: "Active",
            };
        },
        mounted: function ()
        {
            this.LoadData();
        },
        watch: {
            currentRoute()
            {
                this.items = [];
                this.LoadData();
            },
        },
        computed: {
            currentRoute: function ()
            {
                return this.$route.path;
            },
            Title: function ()
            {
                let title = "Constitution";

                return title;
            },
            Description: function ()
            {
                return this.Title;
            }
        },
        metaInfo()
        {
            return {
                title: this.Title,
                meta: [
                    { vmid: 'description', name: 'description', content: this.Description },
                    // OpenGraph data (Most widely used)
                    { vmid: 'og:title', property: 'og:title', content: this.Title + ' | South Dakota Legislature' },
                    // The list of types is available here: http://ogp.me/#types
                    { vmid: 'og:type', property: 'og:type', content: 'website' },
                    // Should be the same as your canonical link, see below.
                    { vmid: 'og:url', property: 'og:url', content: window.location.href },
                    // Often the same as your meta description, but not always.
                    { vmid: 'og:description', property: 'og:description', content: this.Description },

                    // Twitter card
                    { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
                    { vmid: 'twitter:site', name: 'twitter:site', content: window.location.href },
                    { vmid: 'twitter:title', name: 'twitter:title', content: this.Title + ' | South Dakota Legislature' },
                    { vmid: 'twitter:description', name: 'twitter:description', content: this.Description }
                ],
                link: [
                    { vmid: 'canonical', rel: 'canonical', href: window.location.href.split('?')[0].replace('rules', 'Rules').replace('administrative', 'Administrative').replace('statutes', 'Statutes').replace('constitution', 'Constitution').replace('codified_laws', 'Codified_Laws').replace('session_laws', 'Session_Laws') }
                ]
            };
        }
    };
</script>
<style></style>